const hostUrl = 'https://api-azure.btisinc.com/';
export const environment = {
    production: false,
    gatewayUrl: hostUrl + 'GL/v1/aigateway/Gateway',
    baseUrl: hostUrl
};